export var CustomerInvoicingStatuses;
(function (CustomerInvoicingStatuses) {
    CustomerInvoicingStatuses["qa"] = "qa";
    CustomerInvoicingStatuses["live"] = "live";
})(CustomerInvoicingStatuses || (CustomerInvoicingStatuses = {}));
export var CustomerStatuses;
(function (CustomerStatuses) {
    CustomerStatuses["active"] = "active";
    CustomerStatuses["inactive"] = "inactive";
    CustomerStatuses["suspended"] = "suspended";
    CustomerStatuses["blocked"] = "blocked";
    CustomerStatuses["deleted"] = "DELETED";
})(CustomerStatuses || (CustomerStatuses = {}));
//# sourceMappingURL=constants.js.map